import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";
import { Brand } from "../../model/brand.model";
import { BrandsService } from "../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";

function BrandDetails(this: any) {
  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = useState(1);
  const [brandName, setBrandName] = useState("");
  const [selectedBrandId, setSelectedBrandId] = React.useState("");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const brandsService = new BrandsService();
  const [selectedVisibility, setSelectedVisibility] = React.useState("");
  const [brandImage, setbrandImage] = useState("");
  const [brandImageData, setbrandImageData] = useState("");
  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);
  const location = useLocation();

  const loadAllBrands = () => {

    brandsService.brands(-1).then(data => {
      const res = data.data;
      setAvailableBrands(res);

    });
  }

  let parameters = {}
  let iscalled = false;
  useEffect(() => {
    //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
    if (!iscalled) {
      iscalled = true


      if (location != null && location.state != null && location.state.brandDetails != null) {
        parameters = location.state.categoryDetails;

        console.log("params ", parameters)

        setSelectedBrandId(location.state.brandDetails.brandId)
        setBrandName(location.state.brandDetails.brandName)
        setbrandImage(((location.state.brandDetails.brandImage).split("/").pop()))
        setStatus(location.state.brandDetails.status)
        setIsEdit(false)
        setSelectedVisibility(location.state.brandDetails.visibility)

      }
    }
  }, []);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };


  const [submitClick, setsubmitClick] = React.useState(false);
  const createNewBrand = () => {

    if (brandName == "" || brandName == null || brandImage == "" || brandImage == null || selectedVisibility == null) {
      setsubmitClick(true)
      return
    }

    const data = {
      "brandId": selectedBrandId,
      "status": status,
      "brandName": brandName,
      "brandImage": brandImage,
      "brandImageData": brandImageData,
      "visibility" : selectedVisibility
    };
    brandsService.createBrand(data).then((res: any) => {
      if (res.status == '100') {

        toast.success("Updated Successfully !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../brands');
        }, 2100);

      } else {
        toast.error("No Data Available!!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../brands');
        }, 2100);
      }
    })
  };

  const onUploadBrandImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {

        setbrandImage(file.name);

        setbrandImageData(reader.result as string);

      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  return (
    <div className="App">
      <div className="card m-8">

        <div className="card-body ">

          <div className="row pt-4">


            <div className="col-md-4 text-left">
              <div className="form-group  font_size_13px">

                <TextField size="small" label="Brand Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                  type="text" className="form-control" name='prodDispName' value={brandName}
                  error={submitClick && (brandName == "" || brandName == null)}
                  //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

                  disabled={!isedit}
                  onChange={(e: any) => {
                    setBrandName(e.target.value)
                  }}
                />
              </div>
            </div>

            <div className='col-md-4 text-left'>


              <div className="form-group ">
                <TextField size="small" label="Brand Image ( . png Only )" id="outlined-start-adornment" inputProps={{ accept: "application/pdf" }} InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                  className="form-control" name='cad' value={brandImage}
                  error={submitClick && (brandImage == "" || brandImage == null)}
                  InputProps={{
                    sx: { height: 30 },
                    endAdornment: (
                      <IconButton component="label"  >
                        <FileUploadOutlinedIcon />
                        <input style={{ display: "none" }} type="file" accept="image/png,image/jpeg,image/jpg" hidden onChange={(event) => onUploadBrandImg(event)} name="cadFileHiddenImg"
                        />
                      </IconButton>
                    ),
                  }}
                />
              </div>


            </div>

            <div className='col-md-4 text-left'>

              <div className="form-group ">

                <TextField select size="small" label="Visibility" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined" InputProps={{ sx: { height: 30 } }}
                  className="form-control" name='visibility' defaultValue="select" value={selectedVisibility}
                  onChange={(e: any) => {
                    setSelectedVisibility(e.target.value);
                    
                  }}
                >
                  <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
                  <MenuItem style={{ fontSize: "small" }}  value="E" key="enterprise">Enterprise Only</MenuItem>
                  <MenuItem style={{ fontSize: "small" }} value="B" key="entret">Enterprise & Retail</MenuItem>
                  
                </TextField>

              </div>
            </div>

            <div className="col-md-4 text-left">
              <div className="form-group"  >
                <label className="form-group mr-3 pt-2" > Status</label>
                <FormControl><RadioGroup row name='status' value={status}
                  onChange={(e) => { setStatus(Number(e.target.value)) }} >
                  <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
                </FormControl>
              </div>
            </div>

          </div>
        </div>
        <div className="card-footer col-12 text-center">
          <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewBrand()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../brands')} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>
        </div>
      </div>

      <ToastContainer />

    </div>
  );
}

export default BrandDetails;
